module.exports = __webpack_public_path__ + "static/media/experience_image_3@2x.219125bc.png";